/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Edit_Login_CountInputs */

const en_forms_users_edit_login_count = /** @type {(inputs: Forms_Users_Edit_Login_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Count`)
};

const de_forms_users_edit_login_count = /** @type {(inputs: Forms_Users_Edit_Login_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl`)
};

/**
* | output |
* | --- |
* | "Count" |
*
* @param {Forms_Users_Edit_Login_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_edit_login_count = /** @type {((inputs?: Forms_Users_Edit_Login_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Edit_Login_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_edit_login_count(inputs)
	return de_forms_users_edit_login_count(inputs)
});